module.exports = __webpack_public_path__ + "static/media/qasir_user_dashboard.a41cc1b3.JPG";